import { Component } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from "src/app/core/service/auth.service";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { UserService } from "src/app/core/service/user.service";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";

@Component({
    selector: "app-change-password-after-login",
    templateUrl: "./change-password-after-login.component.html",
    styleUrls: ["./change-password-after-login.component.scss"]
})
export class ChangePasswordAfterLoginComponent {
    validPassword: boolean;
    loading: boolean;
    oldPassword = "";
    newPassword = "";

    callBack: string;

    constructor(
        private router: Router,
        private translate: TranslateService,
        private snackBar: MatSnackBar,
        private userService: UserService,
        private authService: AuthService,
        private spinnerService: NgxSpinnerService,
        private subscriptionService: SubscriptionService,
        route: ActivatedRoute
    ) {
        route.queryParams.subscribe((data) => {
            this.callBack = data.callbackUrl || "/";
        });

        translate.setTranslation("pt-BR", ptBR, true);
        translate.setTranslation("en-US", enUS, true);
        translate.setTranslation("es-ES", esES, true);
    }

    logout(): void {
        this.authService.logout().subscribe(() => {
            this.router.navigateByUrl("/");
        });
    }

    save(): void {
        if (!this.validPassword) return;

        this.spinnerService.show();

        this.userService.updateUserPassword(this.oldPassword, this.newPassword).subscribe(
            () => {
                this.spinnerService.hide();
                this.snackBar.open(this.translate.instant("CHANGE_PASSWORD.SAVED"), "OK", { duration: 3000 });
                this.router.navigateByUrl(this.callBack);
            },
            () => {
                this.spinnerService.hide();
                this.snackBar.open(this.translate.instant("CHANGE_PASSWORD.ERROR"), "OK", {
                    duration: 10000,
                    panelClass: "msg-error"
                });
            }
        );
    }

    getPasswordRegex(): string {
        return this.subscriptionService.currentSubscription?.loginSettings?.defaultLoginOptions?.passwordRegex;
    }

    getPasswordCustomRules(): string {
        return this.subscriptionService.currentSubscription?.loginSettings?.defaultLoginOptions?.passwordCustomRules;
    }
}
